import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './QuestionnairePage.css' // Предполагаем, что создадим отдельный CSS файл для стилей

const QuestionnairePage = ({ talentIndices, talents, updateUserData }) => {
  const [talentLevels, setTalentLevels] = useState([])
  const [satisfactionLevels, setSatisfactionLevels] = useState([])
  const [talentResponses, setTalentResponses] = useState([])
  const [currentTalentIndex, setCurrentTalentIndex] = useState(0)
  const [selectedLevel, setSelectedLevel] = useState(null)
  const [selectedSatisfaction, setSelectedSatisfaction] = useState(null)
  const [response, setResponse] = useState('')
  const [levelDescriptions, setLevelDescriptions] = useState([])
  const navigate = useNavigate()

  // Проверка наличия данных
  useEffect(() => {
    if (!talents || talents.length === 0 || !talentIndices || talentIndices.length === 0) {
      console.error('Ошибка: отсутствуют данные о талантах')
      navigate('/birth-location') // Возвращаемся на предыдущую страницу
    }
  }, [talents, talentIndices, navigate])

  // Получаем описания уровней для текущего таланта
  useEffect(() => {
    if (talents && talentIndices && talentIndices.length > 0) {
      const currentTalentId = talentIndices[currentTalentIndex]
      const currentTalent = talents.find(
        (talent) => Number(talent.Number) === Number(currentTalentId),
      )

      if (currentTalent && currentTalent.Levels) {
        // Разбиваем строку уровней на массив, учитывая формат из БД
        const levelsStr = currentTalent.Levels
        const descriptions = [
          levelsStr.includes('Нет (не развита):')
            ? levelsStr.split('Нет (не развита):')[1].split('На низком уровне:')[0].trim()
            : '',
          levelsStr.includes('На низком уровне:')
            ? levelsStr.split('На низком уровне:')[1].split('Средний уровень:')[0].trim()
            : '',
          levelsStr.includes('Средний уровень:')
            ? levelsStr.split('Средний уровень:')[1].split('Выше среднего:')[0].trim()
            : '',
          levelsStr.includes('Выше среднего:')
            ? levelsStr.split('Выше среднего:')[1].split('Высокий уровень:')[0].trim()
            : '',
          levelsStr.includes('Высокий уровень:')
            ? levelsStr.split('Высокий уровень:')[1].trim()
            : '',
        ]
        setLevelDescriptions(descriptions)
        console.log('Parsed level descriptions:', descriptions)
      } else {
        setLevelDescriptions([])
      }

      // Сбрасываем выбранные значения при смене таланта
      setSelectedLevel(null)
      setSelectedSatisfaction(null)
      setResponse('')

      // Проверяем, есть ли уже сохраненные ответы для текущего таланта
      if (talentLevels && talentLevels.length > 0) {
        const savedLevel = talentLevels.find(
          (item) => Number(item.talentId) === Number(currentTalentId),
        )
        if (savedLevel) {
          setSelectedLevel(savedLevel.level)
        }
      }

      if (satisfactionLevels && satisfactionLevels.length > 0) {
        const savedSatisfaction = satisfactionLevels.find(
          (item) => Number(item.talentId) === Number(currentTalentId),
        )
        if (savedSatisfaction) {
          setSelectedSatisfaction(savedSatisfaction.level)
        }
      }

      if (talentResponses && talentResponses.length > 0) {
        const savedResponse = talentResponses.find(
          (item) => Number(item.talentId) === Number(currentTalentId),
        )
        if (savedResponse) {
          setResponse(savedResponse.response)
        }
      }
    }
  }, [
    currentTalentIndex,
    talentIndices,
    talents,
    talentLevels,
    satisfactionLevels,
    talentResponses,
  ])

  // Если данных нет, показываем загрузку
  if (!talents || talents.length === 0 || !talentIndices || talentIndices.length === 0) {
    return (
      <div className="container">
        <div className="header">
          <div className="logo">
            Business <span>Evolution AI</span>
          </div>
        </div>
        <h2>Загрузка данных...</h2>
      </div>
    )
  }

  // Получаем текущий талант
  const currentTalentId = talentIndices[currentTalentIndex]
  const currentTalent = talents.find((talent) => Number(talent.Number) === Number(currentTalentId))

  if (!currentTalent) {
    return (
      <div className="container">
        <div className="header">
          <div className="logo">
            Business <span>Evolution AI</span>
          </div>
        </div>
        <h2>Талант не найден</h2>
        <p>Произошла ошибка при загрузке данных о таланте.</p>
        <button onClick={() => navigate('/birth-location')} className="btn">
          Вернуться назад
        </button>
      </div>
    )
  }

  // Обработчик изменения текстового ответа
  const handleResponseChange = (e) => {
    setResponse(e.target.value)
  }

  // Обработчик выбора уровня развития
  const handleLevelSelect = (level) => {
    setSelectedLevel(level)
  }

  // Обработчик выбора уровня удовлетворенности
  const handleSatisfactionSelect = (level) => {
    setSelectedSatisfaction(level)
  }

  // Функция для получения описания уровня по его номеру
  const getLevelDescription = (level) => {
    if (!levelDescriptions || level < 1 || level > levelDescriptions.length) {
      return 'Описание отсутствует'
    }

    const description = levelDescriptions[level - 1]

    // Проверяем, что у нас есть непустое описание
    if (!description || description.trim() === '') {
      return 'Описание для этого уровня отсутствует'
    }

    return description
  }

  // Обработчик сохранения и перехода к следующему таланту
  const handleSubmit = (e) => {
    e.preventDefault()

    if (!selectedLevel) {
      alert('Пожалуйста, выберите уровень развития таланта')
      return
    }

    if (!selectedSatisfaction) {
      alert('Пожалуйста, выберите уровень удовлетворенности')
      return
    }

    if (!response.trim()) {
      alert('Пожалуйста, введите ответ на вопрос')
      return
    }

    // Обновляем данные уровня
    const newTalentLevels = [
      ...talentLevels.filter((item) => item.talentId !== currentTalentId),
      { talentId: currentTalentId, level: selectedLevel },
    ]
    setTalentLevels(newTalentLevels)

    // Обновляем данные удовлетворенности
    const newSatisfactionLevels = [
      ...satisfactionLevels.filter((item) => item.talentId !== currentTalentId),
      { talentId: currentTalentId, level: selectedSatisfaction },
    ]
    setSatisfactionLevels(newSatisfactionLevels)

    // Обновляем ответы
    const newTalentResponses = [
      ...talentResponses.filter((item) => item.talentId !== currentTalentId),
      { talentId: currentTalentId, response },
    ]
    setTalentResponses(newTalentResponses)

    // Обновляем данные в глобальном состоянии
    updateUserData('talentLevels', newTalentLevels)
    updateUserData('satisfactionLevels', newSatisfactionLevels)
    updateUserData('talentResponses', newTalentResponses)

    // Переходим к следующему таланту или завершаем опрос
    if (currentTalentIndex < talentIndices.length - 1) {
      setCurrentTalentIndex((prev) => prev + 1)
    } else {
      navigate('/results')
    }
  }

  // Рендер формы опроса для текущего таланта
  return (
    <div className="container">
      <div className="header">
        <div className="logo">
          Business <span>Evolution AI</span>
        </div>
      </div>

      <h2>Опрос по таланту: {currentTalent.Tittle}</h2>

      <form onSubmit={handleSubmit}>
        {/* Вопрос о таланте */}
        <div className="form-group">
          <label>Вопрос: {currentTalent.Questions}</label>
          <textarea
            name="response"
            rows={4}
            placeholder="Введите ваш ответ"
            value={response}
            onChange={handleResponseChange}
            required
          ></textarea>
        </div>

        {/* Выбор уровня развития */}
        <div className="form-group">
          <label>Оцените уровень развития таланта:</label>

          <div className="level-selector">
            {[1, 2, 3, 4, 5].map((level) => (
              <div key={`level-${level}`} className="level-option">
                <button
                  type="button"
                  className={`level-button ${selectedLevel === level ? 'selected' : ''}`}
                  onClick={() => handleLevelSelect(level)}
                >
                  {level}
                </button>
                <div className="level-description">
                  {level === 1 && 'Не развита'}
                  {level === 2 && 'На низком уровне'}
                  {level === 3 && 'Средний уровень'}
                  {level === 4 && 'Выше среднего'}
                  {level === 5 && 'Высокий уровень'}
                </div>
              </div>
            ))}
          </div>

          {selectedLevel && (
            <div className="selected-level-description">
              <strong>
                {selectedLevel === 1 && 'Не развита (уровень 1):'}
                {selectedLevel === 2 && 'На низком уровне (уровень 2):'}
                {selectedLevel === 3 && 'Средний уровень (уровень 3):'}
                {selectedLevel === 4 && 'Выше среднего (уровень 4):'}
                {selectedLevel === 5 && 'Высокий уровень (уровень 5):'}
              </strong>
              <p>{getLevelDescription(selectedLevel)}</p>
            </div>
          )}
        </div>

        {/* Выбор уровня удовлетворенности */}
        <div className="form-group">
          <label>Оцените уровень удовлетворенности от использования таланта:</label>

          <div className="satisfaction-selector">
            {[1, 2, 3, 4, 5].map((level) => (
              <button
                key={`sat-${level}`}
                type="button"
                className={`satisfaction-button ${selectedSatisfaction === level ? 'selected' : ''}`}
                onClick={() => handleSatisfactionSelect(level)}
              >
                {level}
                <div className="satisfaction-description">
                  {level === 1 ? 'Выгорание' : ''}
                  {level === 2 ? 'Неудовлетворенность' : ''}
                  {level === 3 ? 'Нейтрально' : ''}
                  {level === 4 ? 'Интерес' : ''}
                  {level === 5 ? 'Вдохновение' : ''}
                </div>
              </button>
            ))}
          </div>
        </div>

        <button type="submit" className="btn">
          {currentTalentIndex < talentIndices.length - 1 ? 'Следующий талант' : 'Завершить опрос'}
        </button>
      </form>

      <div className="progress">
        Талант {currentTalentIndex + 1} из {talentIndices.length}
      </div>
    </div>
  )
}

export default QuestionnairePage
